import type { BibleQuestion } from '../types/bibleQuiz.ts';

export const BIBLE_QUIZ_QUESTIONS: BibleQuestion[] = [
  // =========================================================================
  // 1. CỰU ƯỚC (OLD TESTAMENT)
  // =========================================================================
  {
    id: 'co_001',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Cuốn sách đầu tiên trong bộ Kinh Thánh là cuốn sách nào?',
    options: ['Sách Xuất Hành', 'Sách Sáng Thế', 'Sách Lêvi', 'Sách Khải Huyền'],
    correctIndex: 1,
    explanation: 'Sách Sáng Thế (Genesis) là cuốn sách mở đầu của bộ Kinh Thánh, ghi lại công trình sáng tạo vũ trụ và con người.',
    scriptureRef: 'St 1, 1-31',
  },
  {
    id: 'co_002',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Thiên Chúa đã sáng tạo vũ trụ và vạn vật trong bao nhiêu ngày trước khi Ngài nghỉ ngơi?',
    options: ['5 ngày', '6 ngày', '7 ngày', '10 ngày'],
    correctIndex: 1,
    explanation: 'Thiên Chúa dựng nên vạn vật trong 6 ngày, và ngày thứ bảy Ngài nghỉ ngơi và thánh hóa ngày ấy.',
    scriptureRef: 'St 2, 1-3',
  },
  {
    id: 'co_003',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Ai là người được Chúa truyền lệnh đóng con tàu lớn để cứu gia đình và các loài vật khỏi trận Đại Hồng Thủy?',
    options: ['Ông Áp-ra-ham', 'Ông Nô-ê', 'Ông Mô-sê', 'Ông Đa-vít'],
    correctIndex: 1,
    explanation: 'Ông Nô-ê là người công chính trước mặt Chúa, đã vâng lời đóng tàu để bảo tồn sự sống trong cơn Đại Hồng Thủy.',
    scriptureRef: 'St 6, 13-22',
  },
  {
    id: 'co_004',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Ai được gọi là "Cha của những kẻ tin" hay Tổ phụ của dân Chúa?',
    options: ['Tổ phụ Áp-ra-ham', 'Tổ phụ Gia-cóp', 'Tổ phụ I-xa-ác', 'Vua Sa-lô-môn'],
    correctIndex: 0,
    explanation: 'Tổ phụ Áp-ra-ham đã đáp lại tiếng gọi của Chúa rời quê hương, sẵn lòng hiến dâng con một và trở thành tổ phụ của các kẻ tin.',
    scriptureRef: 'St 12, 1-4; Rm 4, 11',
  },
  {
    id: 'co_005',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Thiên Chúa đã ban Mười Điều Răn cho dân Do Thái qua trung gian ai trên núi Si-nai?',
    options: ['Ông A-hôn', 'Ông Mô-sê', 'Ông Giô-suê', 'Ông Sam-sôn'],
    correctIndex: 1,
    explanation: 'Ông Mô-sê đã lên núi Si-nai diện kiến Thiên Chúa và nhận hai bia đá khắc Mười Lời Giao Ước (Mười Điều Răn).',
    scriptureRef: 'Xh 20, 1-17; Đnl 5, 1-22',
  },
  {
    id: 'co_006',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Dấu chỉ giao ước Thiên Chúa đã đặt giữa trời sau trận Đại Hồng Thủy là gì?',
    options: ['Cột lửa ban đêm', 'Cầu vồng bảy sắc', 'Bụi gai rực cháy', 'Mặt trời đứng yên'],
    correctIndex: 1,
    explanation: 'Thiên Chúa phán: "Ta gác cung mây (cầu vồng) của Ta trên bầu trời làm dấu chỉ giao ước giữa Ta với mặt đất."',
    scriptureRef: 'St 9, 12-17',
  },
  {
    id: 'co_007',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Ai đã dùng một viên sỏi từ dây ném đá để quật ngã tên khổng lồ Gô-li-át?',
    options: ['Sa-un', 'Đa-vít', 'Sa-lô-môn', 'Giô-na-than'],
    correctIndex: 1,
    explanation: 'Chàng trai trẻ Đa-vít tin cậy vào danh Đức Chúa đã đánh bại tên dũng sĩ khổng lồ Gô-li-át xứ Phi-li-tinh.',
    scriptureRef: '1 Sm 17, 48-50',
  },
  {
    id: 'co_008',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Vị vua nào nổi tiếng trong Kinh Thánh về sự khôn ngoan và là người đã xây dựng Đền Thờ đầu tiên tại Giê-ru-sa-lem?',
    options: ['Vua Sa-un', 'Vua Đa-vít', 'Vua Sa-lô-môn', 'Vua Kê-đê-ki-a'],
    correctIndex: 2,
    explanation: 'Vua Sa-lô-môn xin Chúa ban ơn khôn ngoan để cai trị dân và đã xây dựng Đền Thờ Giê-ru-sa-lem nguy nga rực rỡ.',
    scriptureRef: '1 V 3, 5-14; 1 V 6, 1-38',
  },
  {
    id: 'co_009',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Ngôn sứ nào đã ở trong bụng một con cá lớn suốt ba ngày ba đêm trước khi đến thành Ni-ni-vê?',
    options: ['Ngôn sứ Ê-li-a', 'Ngôn sứ Giô-na', 'Ngôn sứ A-mốt', 'Ngôn sứ Mi-kha'],
    correctIndex: 1,
    explanation: 'Ngôn sứ Giô-na trốn lệnh Chúa đi Tác-sít nhưng bị quăng xuống biển và được cá lớn nuốt vào bụng 3 ngày 3 đêm.',
    scriptureRef: 'Gn 2, 1-11',
  },
  {
    id: 'co_010',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Thức ăn lạ lùng mà Thiên Chúa ban từ trời xuống nuôi dưỡng dân Israel trong 40 năm sa mạc có tên là gì?',
    options: ['Man-na', 'Bánh ngọt ba tầng', 'Ngũ cốc hoàng gia', 'Quả ô-liu vàng'],
    correctIndex: 0,
    explanation: 'Man-na là bánh từ trời rơi xuống như sương mai hằng sáng, nuôi dưỡng dân Israel suốt hành trình vượt sa mạc.',
    scriptureRef: 'Xh 16, 14-36',
  },
  {
    id: 'co_011',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'hard',
    question: 'Ngôn sứ nào đã chứng kiến cỗ xe lửa và bão táp đưa mình lên trời mà không phải trải qua sự chết tự nhiên?',
    options: ['Ngôn sứ Ê-li-sa', 'Ngôn sứ Ê-li-a', 'Ngôn sứ I-sai-a', 'Ngôn sứ Giê-rê-mi-a'],
    correctIndex: 1,
    explanation: 'Ngôn sứ Ê-li-a được xe lửa và chiến mã lửa rước lên trời trong một cơn gió lốc trước sự chứng kiến của Ê-li-sa.',
    scriptureRef: '2 V 2, 11-12',
  },
  {
    id: 'co_012',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'hard',
    question: 'Ai đã bị ném vào hầm sư tử vì kiên trung cầu nguyện cùng Thiên Chúa ba lần mỗi ngày nhưng được Chúa sai thiên thần gìn giữ vô hại?',
    options: ['Đa-ni-en', 'Sa-đơ-rác', 'Mê-sác', 'A-bết Nơ-gô'],
    correctIndex: 0,
    explanation: 'Ngôn sứ Đa-ni-en bị tống vào hầm sư tử dưới thời vua Đa-ri-ô, nhưng Chúa đã khóa hàm sư tử gìn giữ người công chính.',
    scriptureRef: 'Đn 6, 11-24',
  },
  {
    id: 'co_013',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'hard',
    question: 'Nhân vật nào trong Cựu Ước chịu mất hết của cải, con cái và mắc bệnh phong hủi nhưng vẫn thốt lên: "Chúa ban cho, Chúa lấy đi, xin chúc tụng danh Chúa!"?',
    options: ['Ông Gióp', 'Ông Tô-bi-a', 'Ông Giô-xép', 'Ông Nê-hê-mi-a'],
    correctIndex: 0,
    explanation: 'Ông Gióp là tấm gương kiên trì son sắt, giữ vững đức tin dẫu trong cơn thử thách đau đớn tột cùng.',
    scriptureRef: 'G 1, 21-22',
  },
  {
    id: 'co_014',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'easy',
    question: 'Bộ sách Cựu Ước trong quy điển Công giáo gồm tổng cộng bao nhiêu cuốn sách?',
    options: ['39 cuốn', '46 cuốn', '27 cuốn', '73 cuốn'],
    correctIndex: 1,
    explanation: 'Quy điển Công giáo nhìn nhận 46 cuốn sách trong Cựu Ước và 27 cuốn trong Tân Ước (tổng cộng 73 cuốn).',
    scriptureRef: 'Giáo lý Hội Thánh Công giáo, số 120',
  },
  {
    id: 'co_015',
    category: 'cuu_uoc',
    categoryName: 'Cựu Ước',
    difficulty: 'medium',
    question: 'Ngôn sứ nào được gọi là "Ngôn sứ về Đấng Thiên Sai đau khổ" với bài ca Người Tôi Trung chịu hiến tế vì tội lỗi muôn dân?',
    options: ['I-sai-a', 'Ê-dê-ki-en', 'Giê-rê-mi-a', 'Hô-sê'],
    correctIndex: 0,
    explanation: 'Sách Ngôn sứ I-sai-a chương 53 miêu tả tỉ mỉ Người Tôi Trung gánh lấy bệnh hoạn tật nguyền và chịu đâm thâu vì tội ác loài người.',
    scriptureRef: 'Is 53, 1-12',
  },

  // =========================================================================
  // 2. TÂN ƯỚC (NEW TESTAMENT)
  // =========================================================================
  {
    id: 'nt_001',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'easy',
    question: 'Bốn sách Tin Mừng (Phúc Âm) trong Tân Ước theo thứ tự quy điển là gì?',
    options: [
      'Mát-thêu, Mác-cô, Lu-ca, Gio-an',
      'Gio-an, Lu-ca, Mác-cô, Mát-thêu',
      'Phê-rô, Phao-lô, Gia-cô-bê, Gio-an',
      'Mô-sê, Đa-vít, I-sai-a, Giê-su',
    ],
    correctIndex: 0,
    explanation: 'Bốn sách Tin Mừng quy điển xếp theo thứ tự: Mát-thêu, Mác-cô, Lu-ca, và Gio-an.',
    scriptureRef: 'Quy điển Tân Ước',
  },
  {
    id: 'nt_002',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'easy',
    question: 'Chúa Giêsu đã sinh ra tại thành phố nào xứ Giu-đê?',
    options: ['Na-da-rét', 'Giê-ru-sa-lem', 'Bê-lem', 'Ca-phéc-na-um'],
    correctIndex: 2,
    explanation: 'Chúa Giêsu giáng sinh tại Bê-lem theo đúng lời các ngôn sứ đã tiên báo từ ngàn xưa.',
    scriptureRef: 'Mt 2, 1; Lc 2, 4-7',
  },
  {
    id: 'nt_003',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'easy',
    question: 'Ai là vị tiền hô đã làm phép rửa cho Chúa Giêsu tại sông Gio-đan?',
    options: ['Thánh Gioan Tẩy Giả', 'Thánh Phêrô', 'Thánh Giuse', 'Ngôn sứ Ê-li-a'],
    correctIndex: 0,
    explanation: 'Thánh Gioan Tẩy Giả đã kêu gọi sám hối và cử hành phép rửa cho Chúa Giêsu bên bờ sông Gio-đan.',
    scriptureRef: 'Mt 3, 13-17',
  },
  {
    id: 'nt_004',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'easy',
    question: 'Phép lạ đầu tiên Chúa Giêsu thực hiện trong đời sống công khai là gì?',
    options: [
      'Cho Ladarô sống lại',
      'Hóa bánh ra nhiều',
      'Biến nước thành rượu tại tiệc cưới Cana',
      'Chữa người mù bẩm sinh',
    ],
    correctIndex: 2,
    explanation: 'Nhờ lời chuyển cầu của Đức Mẹ Maria, Chúa Giêsu đã biến nước thành rượu ngon tại tiệc cưới Cana xứ Galilê.',
    scriptureRef: 'Ga 2, 1-11',
  },
  {
    id: 'nt_005',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'easy',
    question: 'Bài giảng trên núi nổi tiếng của Chúa Giêsu mở đầu bằng điều gì?',
    options: ['Mười Điều Răn mới', 'Tám Mối Phúc Thật', 'Kinh Kính Mừng', 'Dụ ngôn hạt giống'],
    correctIndex: 1,
    explanation: 'Chúa Giêsu khai mở Hiến chương Nước Trời bằng Tám Mối Phúc Thật (Mt 5, 3-12).',
    scriptureRef: 'Mt 5, 1-12',
  },
  {
    id: 'nt_006',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'medium',
    question: 'Trong bữa Tiệc Ly, Chúa Giêsu đã làm hành động khiêm hạ nào đối với các môn đệ trước khi thiết lập Bí Tích Thánh Thể?',
    options: ['Trao áo choàng', 'Rửa chân cho các môn đệ', 'Dâng hương trầm', 'Xức dầu thơm lên đầu'],
    correctIndex: 1,
    explanation: 'Chúa Giêsu đã cúi mình rửa chân cho từng môn đệ và dạy: "Thầy đã nêu gương cho anh em, để anh em cũng làm như Thầy đã làm."',
    scriptureRef: 'Ga 13, 1-15',
  },
  {
    id: 'nt_007',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'medium',
    question: 'Dụ ngôn nào nói về lòng thương xót vô biên của Chúa Cha sẵn sàng đón nhận và mở tiệc ăn mừng người con tội lỗi trở về?',
    options: [
      'Dụ ngôn người gieo giống',
      'Dụ ngôn người cha nhân hậu (Người con hoang đàng)',
      'Dụ ngôn kho tàng chôn giấu',
      'Dụ ngôn mười trinh nữ',
    ],
    correctIndex: 1,
    explanation: 'Dụ ngôn Người cha nhân hậu (Lc 15, 11-32) là tuyệt đỉnh Tin Mừng về lòng thương xót và tha thứ.',
    scriptureRef: 'Lc 15, 11-32',
  },
  {
    id: 'nt_008',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'medium',
    question: 'Kinh nguyện hoàn hảo nhất mà chính Chúa Giêsu đã trực tiếp dạy các môn đệ cầu nguyện là gì?',
    options: ['Kinh Tin Kính', 'Kinh Lạy Cha', 'Kinh Kính Mừng', 'Kinh Sáng Soi'],
    correctIndex: 1,
    explanation: 'Khi các môn đệ xin: "Thưa Thầy, xin dạy chúng con cầu nguyện", Chúa Giêsu đã dạy Kinh Lạy Cha.',
    scriptureRef: 'Mt 6, 9-13; Lc 11, 1-4',
  },
  {
    id: 'nt_009',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'hard',
    question: 'Trên đường đi Đa-mát để lùng bắt các Kitô hữu, ai đã được ánh sáng từ trời chiếu rọi, nghe tiếng Chúa phán và hoán cải thành Tông đồ dân ngoại?',
    options: ['Thánh Ba-na-ba', 'Thánh Phao-lô (Sao-lô)', 'Thánh Ti-mô-thê', 'Thánh Tê-pha-nô'],
    correctIndex: 1,
    explanation: 'Sao-lô đã ngã ngựa, nghe tiếng Chúa Giêsu: "Sao-lô, sao ngươi bắt bớ Ta?" và trở thành Thánh Phaolô vĩ đại.',
    scriptureRef: 'Cv 9, 1-19',
  },
  {
    id: 'nt_010',
    category: 'tan_uoc',
    categoryName: 'Tân Ước',
    difficulty: 'hard',
    question: 'Cuốn sách cuối cùng trong Tân Ước và toàn bộ bộ Kinh Thánh là cuốn sách nào?',
    options: ['Thư gửi tín hữu Do Thái', 'Sách Công Vụ Tông Đồ', 'Sách Khải Huyền', 'Thư thứ hai của Phêrô'],
    correctIndex: 2,
    explanation: 'Sách Khải Huyền (Apocalypse) do Thánh Gioan ghi chép tại đảo Bát-mô là sách khép lại bộ Kinh Thánh với viễn cảnh Trời Mới Đất Mới.',
    scriptureRef: 'Kh 21 - 22',
  },

  // =========================================================================
  // 3. BẢY BÍ TÍCH & ĐỜI SỐNG ĐỨC TIN (THE SACRAMENTS)
  // TUYỆT ĐỐI TUÂN THỦ: "Bí Tích" VIẾT HOA CẢ HAI TỪ
  // =========================================================================
  {
    id: 'bt_001',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'easy',
    question: 'Hội Thánh Công Giáo cử hành bao nhiêu Bí Tích do chính Chúa Giêsu Kitô thiết lập?',
    options: ['3 Bí Tích', '5 Bí Tích', '7 Bí Tích', '12 Bí Tích'],
    correctIndex: 2,
    explanation: 'Có 7 Bí Tích: Bí Tích Rửa Tội, Bí Tích Thêm Sức, Bí Tích Thánh Thể, Bí Tích Hòa Giải, Bí Tích Xức Dầu Bệnh Nhân, Bí Tích Truyền Chức Thánh, và Bí Tích Hôn Phối.',
    scriptureRef: 'GLHTCG số 1210',
  },
  {
    id: 'bt_002',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'easy',
    question: 'Ba Bí Tích nào hợp thành nhóm các Bí Tích Khai Tâm Kitô giáo?',
    options: [
      'Bí Tích Rửa Tội, Bí Tích Thêm Sức, Bí Tích Thánh Thể',
      'Bí Tích Rửa Tội, Bí Tích Hòa Giải, Bí Tích Hôn Phối',
      'Bí Tích Thánh Thể, Bí Tích Truyền Chức Thánh, Bí Tích Thêm Sức',
      'Bí Tích Hòa Giải, Bí Tích Xức Dầu Bệnh Nhân, Bí Tích Rửa Tội',
    ],
    correctIndex: 0,
    explanation: 'Ba Bí Tích Khai Tâm Kitô giáo là Bí Tích Rửa Tội, Bí Tích Thêm Sức và Bí Tích Thánh Thể, đặt nền tảng cho toàn bộ đời sống người Kitô hữu.',
    scriptureRef: 'GLHTCG số 1212',
  },
  {
    id: 'bt_003',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'easy',
    question: 'Bí Tích nào là cửa ngõ bước vào đời sống thiêng liêng và là điều kiện cần thiết để lãnh nhận các Bí Tích khác?',
    options: ['Bí Tích Thêm Sức', 'Bí Tích Rửa Tội', 'Bí Tích Hòa Giải', 'Bí Tích Thánh Thể'],
    correctIndex: 1,
    explanation: 'Bí Tích Rửa Tội tái sinh con người trong nước và Thánh Thần, tha thứ tội tổ tông và mọi tội riêng, tháp nhập chúng ta vào Thân Thể mầu nhiệm Chúa Kitô.',
    scriptureRef: 'GLHTCG số 1213; Ga 3, 5',
  },
  {
    id: 'bt_004',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'easy',
    question: 'Bí Tích nào được xưng tụng là "Nguồn mạch và chóp đỉnh của toàn bộ đời sống Kitô giáo"?',
    options: ['Bí Tích Hòa Giải', 'Bí Tích Thánh Thể', 'Bí Tích Truyền Chức Thánh', 'Bí Tích Rửa Tội'],
    correctIndex: 1,
    explanation: 'Bí Tích Thánh Thể chứa đựng chính Chúa Giêsu Kitô - Đấng Cứu Độ muôn loài, là chóp đỉnh mọi ân sủng phụng vụ.',
    scriptureRef: 'Hiến chế Lumen Gentium, số 11; GLHTCG số 1324',
  },
  {
    id: 'bt_005',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'medium',
    question: 'Hai Bí Tích nào được gọi là các Bí Tích Chữa Lành trong đời sống đức tin?',
    options: [
      'Bí Tích Hòa Giải và Bí Tích Xức Dầu Bệnh Nhân',
      'Bí Tích Rửa Tội và Bí Tích Thêm Sức',
      'Bí Tích Truyền Chức Thánh và Bí Tích Hôn Phối',
      'Bí Tích Thánh Thể và Bí Tích Hòa Giải',
    ],
    correctIndex: 0,
    explanation: 'Bí Tích Hòa Giải chữa lành linh hồn khỏi thương tích tội lỗi, và Bí Tích Xức Dầu Bệnh Nhân củng cố nâng đỡ thể xác lẫn tinh thần người ốm liệt.',
    scriptureRef: 'GLHTCG số 1420-1421',
  },
  {
    id: 'bt_006',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'medium',
    question: 'Những Bí Tích nào in một "ấn tín thiêng liêng không thể tẩy xóa" và do đó chỉ được lãnh nhận DUY NHẤT MỘT LẦN trong đời?',
    options: [
      'Bí Tích Rửa Tội, Bí Tích Thêm Sức, Bí Tích Truyền Chức Thánh',
      'Bí Tích Thánh Thể, Bí Tích Hòa Giải, Bí Tích Hôn Phối',
      'Bí Tích Rửa Tội, Bí Tích Hòa Giải, Bí Tích Xức Dầu Bệnh Nhân',
      'Bí Tích Thêm Sức, Bí Tích Hôn Phối, Bí Tích Truyền Chức Thánh',
    ],
    correctIndex: 0,
    explanation: 'Ba Bí Tích in ấn tín vĩnh viễn không hề phai mờ vào tâm hồn là: Bí Tích Rửa Tội, Bí Tích Thêm Sức, và Bí Tích Truyền Chức Thánh.',
    scriptureRef: 'GLHTCG số 1121',
  },
  {
    id: 'bt_007',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'medium',
    question: 'Chúa Giêsu đã thiết lập Bí Tích Thánh Thể và Bí Tích Truyền Chức Thánh vào biến cố quan trọng nào?',
    options: ['Bữa Tiệc Ly vào tối Thứ Năm Tuần Thánh', 'Sáng Chúa Nhật Phục Sinh', 'Ngày lễ Hiện Xuống', 'Tại tiệc cưới Cana'],
    correctIndex: 0,
    explanation: 'Trong Bữa Tiệc Ly, Chúa Giêsu bẻ bánh, trao chén rượu phán: "Đây là Mình Thầy... Đây là Máu Thầy... Hãy làm việc này mà nhớ đến Thầy."',
    scriptureRef: 'Lc 22, 19-20; 1 Cr 11, 23-26',
  },
  {
    id: 'bt_008',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'medium',
    question: 'Ai là thừa tác viên thông thường để ban Bí Tích Thêm Sức?',
    options: ['Đức Giám mục', 'Thầy phó tế', 'Bố mẹ đỡ đầu', 'Bất kỳ giáo dân nào'],
    correctIndex: 0,
    explanation: 'Đức Giám mục là thừa tác viên nguyên thủy và thông thường của Bí Tích Thêm Sức, tượng trưng cho tính duy nhất và tính tông truyền của Giáo Hội.',
    scriptureRef: 'GLHTCG số 1312-1313',
  },
  {
    id: 'bt_009',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'hard',
    question: 'Trong trường hợp nguy tử khẩn cấp, ai có quyền và nghĩa vụ cử hành Bí Tích Rửa Tội cho người khao khát?',
    options: [
      'Chỉ duy nhất linh mục',
      'Bất kỳ người nào (kể cả người chưa có đức tin) có ý hướng làm điều Giáo Hội làm, dùng nước tự nhiên và đọc công thức Chúa Ba Ngôi',
      'Phải đưa vào nhà thờ trước bàn thờ',
      'Không ai được phép nếu vắng giám mục',
    ],
    correctIndex: 1,
    explanation: 'Khi nguy tử, bất cứ người nào có ý hướng làm điều Giáo Hội làm, đổ nước lên đầu thụ nhân và đọc: "Tôi rửa anh (chị) nhân danh Cha, và Con, và Thánh Thần" thì Bí Tích Rửa Tội hoàn toàn thành sự.',
    scriptureRef: 'GLHTCG số 1256; Giáo luật điều 861 §2',
  },
  {
    id: 'bt_010',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'hard',
    question: 'Ba phẩm trật trong Bí Tích Truyền Chức Thánh theo luật phụng vụ của Hội Thánh là gì?',
    options: [
      'Giám mục, Linh mục, Phó tế',
      'Hồng y, Giám mục, Cha sở',
      'Giáo hoàng, Tổng giám mục, Linh mục',
      'Đan sĩ, Thầy dòng, Giáo lý viên',
    ],
    correctIndex: 0,
    explanation: 'Ba cấp bậc của Bí Tích Truyền Chức Thánh được Chúa thiết lập gồm: Giám mục (cấp trọn vẹn), Linh mục (cộng tác viên), và Phó tế (phục vụ bàn thờ và bác ái).',
    scriptureRef: 'GLHTCG số 1554',
  },
  {
    id: 'bt_011',
    category: 'bi_tich',
    categoryName: 'Các Bí Tích',
    difficulty: 'hard',
    question: 'Để lãnh nhận ơn tha tội qua Bí Tích Hòa Giải một cách trọn vẹn, hối nhân cần thực hiện những bước chính yếu nào?',
    options: [
      'Xét mình, Ăn năn tội, Dốc lòng chừa, Xưng tội cùng linh mục, và Làm việc đền tội',
      'Chỉ cần đọc một kinh Ăn Năn Tội trong lòng',
      'Đóng góp tiền vào hòm bác ái',
      'Đợi đến mùa Giáng Sinh mới cần xưng tội',
    ],
    correctIndex: 0,
    explanation: 'Năm điều kiện để đón nhận trọn vẹn ân sủng từ Bí Tích Hòa Giải: Xét mình kỹ lưỡng, thật lòng ăn năn tội, dốc lòng chừa cải, xưng tội rõ ràng và mau mắn làm việc đền tội.',
    scriptureRef: 'GLHTCG số 1450-1460',
  },

  // =========================================================================
  // 4. PHỤNG VỤ & NĂM THÁNH (LITURGY)
  // =========================================================================
  {
    id: 'pv_001',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'easy',
    question: 'Năm Phụng Vụ của Hội Thánh Công Giáo bắt đầu bằng mùa nào?',
    options: ['Mùa Giáng Sinh', 'Mùa Vọng', 'Mùa Chay', 'Mùa Thường Niên'],
    correctIndex: 1,
    explanation: 'Năm Phụng Vụ khởi đầu vào Chúa Nhật I Mùa Vọng, hướng lòng tín hữu trông đợi Chúa Kitô ngự đến.',
    scriptureRef: 'Quy chế Tổng quát Năm Phụng Vụ',
  },
  {
    id: 'pv_002',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'easy',
    question: 'Mùa Chay thánh kéo dài trong thời gian bao nhiêu ngày, theo gương Chúa Giêsu ăn chay cầu nguyện trong hoang địa?',
    options: ['30 ngày', '40 ngày', '50 ngày', '7 ngày'],
    correctIndex: 1,
    explanation: 'Mùa Chay gồm 40 ngày khởi đầu từ Thứ Tư Lễ Tro, chuẩn bị tâm hồn bước vào mầu nhiệm Phục Sinh.',
    scriptureRef: 'Mt 4, 1-2; Lc 4, 1-2',
  },
  {
    id: 'pv_003',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'easy',
    question: 'Màu áo lễ nào được phụng vụ sử dụng trong Mùa Vọng và Mùa Chay để biểu thị tinh thần sám hối và trông đợi?',
    options: ['Màu Trắng', 'Màu Tím', 'Màu Xanh lá', 'Màu Đỏ'],
    correctIndex: 1,
    explanation: 'Màu tím là màu của sự sám hối, tỉnh thức và khiêm hạ, được dùng trong Mùa Vọng và Mùa Chay.',
    scriptureRef: 'Quy chế Tổng quát Sách Lễ Rôma, số 346',
  },
  {
    id: 'pv_004',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'medium',
    question: 'Tam Nhật Vượt Qua - đỉnh cao của toàn bộ Năm Phụng Vụ - bao gồm những ngày nào?',
    options: [
      'Chiều Thứ Năm Tuần Thánh, Thứ Sáu Tuần Thánh, Thứ Bảy Tuần Thánh cho đến Kinh Chiều Chúa Nhật Phục Sinh',
      'Thứ Hai, Thứ Ba, Thứ Tư Tuần Thánh',
      'Lễ Giáng Sinh, Lễ Hiển Linh, Lễ Mẹ Thiên Chúa',
      'Chúa Nhật Lễ Lá, Thứ Năm Tuần Thánh, Thứ Sáu Tuần Thánh',
    ],
    correctIndex: 0,
    explanation: 'Tam Nhật Vượt Qua tưởng niệm cuộc Thương Khó, Mai Táng và Phục Sinh của Chúa Kitô, khởi từ Thánh Lễ Tiệc Ly chiều Thứ Năm đến chiều Chúa Nhật Phục Sinh.',
    scriptureRef: 'Quy chế Tổng quát Năm Phụng Vụ, số 18-21',
  },
  {
    id: 'pv_005',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'medium',
    question: 'Màu áo lễ Đỏ được dùng trong những thánh lễ nào trong phụng vụ?',
    options: [
      'Chúa Nhật Lễ Lá, Thứ Sáu Tuần Thánh, Lễ Chúa Thánh Thần Hiện Xuống và các ngày lễ kính các Thánh Tử Đạo',
      'Mùa Thường Niên tất cả các tuần',
      'Mùa Giáng Sinh và Mùa Phục Sinh',
      'Thánh lễ an táng thông thường',
    ],
    correctIndex: 0,
    explanation: 'Màu đỏ tượng trưng cho ngọn lửa Chúa Thánh Thần và máu đào minh chứng tình yêu của Chúa Kitô cùng các vị Tử Đạo.',
    scriptureRef: 'Quy chế Sách Lễ Rôma, số 346',
  },
  {
    id: 'pv_006',
    category: 'phung_vu',
    categoryName: 'Phụng Vụ & Năm Thánh',
    difficulty: 'hard',
    question: 'Thánh Lễ Công Giáo gồm có hai phần chính yếu gắn bó mật thiết với nhau là gì?',
    options: [
      'Phụng Vụ Lời Chúa và Phụng Vụ Thánh Thể',
      'Phần Nhập Lễ và Phần Kết Lễ',
      'Lời Nguyện Tín Hữu và Bài Giảng',
      'Kinh Kính Mừng và Kinh Lạy Cha',
    ],
    correctIndex: 0,
    explanation: 'Phụng Vụ Lời Chúa (Bàn tiệc Lời Chúa) và Phụng Vụ Thánh Thể (Bàn tiệc Mình Máu Thánh) hợp thành một hành vi phụng tự duy nhất.',
    scriptureRef: 'Hiến chế Phụng Vụ Sacrosanctum Concilium, số 56',
  },

  // =========================================================================
  // 5. CÁC THÁNH & CHỨNG NHÂN ĐỨC TIN (SAINTS)
  // =========================================================================
  {
    id: 'ct_001',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'easy',
    question: 'Vị thánh nào được Chúa Giêsu đặt làm thủ lãnh nhóm mười hai Tông đồ và trao chìa khóa Nước Trời?',
    options: ['Thánh Gioan', 'Thánh Phêrô', 'Thánh Phaolô', 'Thánh Anrê'],
    correctIndex: 1,
    explanation: 'Chúa Giêsu phán: "Anh là Phêrô, nghĩa là Tảng Đá, trên tảng đá này, Thầy sẽ xây Hội Thánh của Thầy... Thầy sẽ trao cho anh chìa khóa Nước Trời."',
    scriptureRef: 'Mt 16, 18-19',
  },
  {
    id: 'ct_002',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'easy',
    question: 'Ai là bạn thanh sạch của Đức Trinh Nữ Maria, người cha nuôi dưỡng Chúa Cứu Thế và là Đấng Bảo Trợ Hội Thánh hoàn vũ?',
    options: ['Thánh Giuse', 'Thánh Gioan Tẩy Giả', 'Thánh Dacaria', 'Thánh Simêon'],
    correctIndex: 0,
    explanation: 'Thánh Cả Giuse là người công chính, trung tín gìn giữ Thánh Gia và hằng che chở chở che toàn thể Hội Thánh.',
    scriptureRef: 'Mt 1, 18-25; Tông thư Patris Corde',
  },
  {
    id: 'ct_003',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'medium',
    question: 'Hội Thánh Công Giáo Việt Nam hân hoan mừng kính bao nhiêu Vị Thánh Tử Đạo được Đức Thánh Giáo Hoàng Gioan Phaolô II tuyên thánh năm 1988?',
    options: ['100 vị', '117 vị hiển thánh', '120 vị', '200 vị'],
    correctIndex: 1,
    explanation: 'Ngày 19/06/1988, Đức Giáo Hoàng Gioan Phaolô II đã long trọng tôn phong 117 Vị Tử Đạo tại Việt Nam lên bậc Hiển Thánh.',
    scriptureRef: 'Lịch sử Giáo Hội Công Giáo Việt Nam',
  },
  {
    id: 'ct_004',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'medium',
    question: 'Ai là vị Tử đạo tiên khởi của Giáo Hội Việt Nam, được phong Chân Phước và nổi tiếng với câu nói: "Hãy lấy tình yêu đáp lại tình yêu, lấy sự sống đáp lại sự sống"?',
    options: ['Thầy giảng Anrê Phú Yên', 'Thánh Phêrô Tự', 'Thánh Emmanuel Triệu', 'Thánh Vinh Sơn Liêm'],
    correctIndex: 0,
    explanation: 'Thầy giảng Anrê Phú Yên (tử đạo năm 1644 tại Quảng Nam) là vị tử đạo đầu tiên của Giáo Hội Việt Nam, gương mẫu cho giới trẻ.',
    scriptureRef: 'Hạnh tích Chân Phước Anrê Phú Yên',
  },
  {
    id: 'ct_005',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'medium',
    question: 'Nữ tu dòng Thừa Sai Bác Ái đoạt giải Nobel Hòa Bình năm 1979, người đã cống hiến trọn đời chăm sóc những người nghèo khổ nhất tại Calcutta (Ấn Độ) là ai?',
    options: ['Thánh Faustina', 'Thánh Têrêsa Calcutta (Mẹ Têrêsa)', 'Thánh Clara', 'Thánh Bernadette'],
    correctIndex: 1,
    explanation: 'Thánh Mẹ Têrêsa Calcutta dành trọn cuộc đời phục vụ Chúa Kitô nơi những người bần cùng, bệnh tật và bị bỏ rơi nhất.',
    scriptureRef: 'Hạnh tích Thánh Têrêsa Calcutta',
  },
  {
    id: 'ct_006',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'hard',
    question: 'Thánh nữ Têrêsa Hài Đồng Giêsu nổi tiếng với linh đạo nào đã được tuyên phong làm Tiến sĩ Hội Thánh?',
    options: [
      'Con đường thơ ấu thiêng liêng (Phó thác và yêu mến trong những việc nhỏ bé nhất)',
      'Lối tu khổ chế nghiêm ngặt trong sa mạc',
      'Triết học kinh viện hàn lâm',
      'Lập các đạo quân thánh chiến thời trung cổ',
    ],
    correctIndex: 0,
    explanation: 'Thánh Nữ Têrêsa thành Lisieux cống hiến cho Hội Thánh "Con đường bé nhỏ", dạy ta phó thác hoàn toàn nơi vòng tay yêu thương của Cha trên trời.',
    scriptureRef: 'Tự thuật Một Tâm Hồn',
  },
  {
    id: 'ct_007',
    category: 'cac_thanh',
    categoryName: 'Các Thánh & Chứng Nhân',
    difficulty: 'hard',
    question: 'Vị thánh nào là Tiến sĩ Thiên Thần (Doctor Angelicus), tác giả bộ sách "Tổng Luận Thần Học" (Summa Theologiae) kiệt tác của triết học và thần học Công giáo?',
    options: ['Thánh Augustinô', 'Thánh Tôma Aquinô', 'Thánh Bonaventura', 'Thánh Anselmô'],
    correctIndex: 1,
    explanation: 'Thánh Tôma Aquinô (1225-1274) dòng Đa Minh là vị đại tiến sĩ đã kết hợp hài hòa giữa đức tin Kitô giáo và lý trí triết học Aristote.',
    scriptureRef: 'GLHTCG số 43-48; Lịch sử Thần học Công giáo',
  },
];
